<template>
    <div class="product-loading" data-page="1" is-loadmore="" style="display: block;" :style="background ? { background: background } : {}">
        <div class="product-loading__wrapper">
            <div class="product-loading__loader"></div>
            <p class="product-loading__message" v-if="message">{{ message }}</p>
        </div>
	</div>
</template>

<script lang="ts" setup>
  const props = defineProps(["message", "background"]);
</script>

<style scoped lang="scss">
.product-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    background: rgb(0 0 0 / 20%);
    margin-left: 0;

    &__wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    &__loader::before {
        width: 0px;
        height: 0px;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -.5em;
        margin-top: -.5em;
        content: "";
        animation: spin 1s ease-in-out infinite;
        line-height: 1;
        text-align: center;
        font-size: 2em;
        color: rgba(0, 0, 0, .75);
        border: 16px solid #888;
        border-radius: 50%;
        border-top: 16px solid #f3f3f3;
        overflow: hidden;
        background: none;
    }

    &__message {
        margin: 0;
        position: relative;
        top: 40px;
        font-size: 14px;
    }
}

@-moz-keyframes spin {
	100% {
		-moz-transform: rotate(360deg);
	}

}

@-webkit-keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
	}

}

@keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}

}
</style>